const DEFAULT_EMAIL_VISIBLE_CHARS = 2;
const DEFAULT_PHONE_VISIBLE_END = 4;

function maskPart(str: string, visible: number): string {
  if (!str.length) return "";
  if (str.length <= visible)
    return str[0] + "*".repeat(Math.max(0, str.length - 1));
  return str.slice(0, visible) + "*".repeat(str.length - visible);
}

/**
 * Example: "juan@gmail.com" → "ju***@gm***.com"
 */
export function maskEmail(
  email: string,
  visibleChars: number = DEFAULT_EMAIL_VISIBLE_CHARS,
): string {
  const trimmed = email.trim();
  if (!trimmed) return "***";
  const atIndex = trimmed.indexOf("@");
  if (atIndex === -1)
    return maskPart(trimmed, Math.min(visibleChars, trimmed.length));
  const local = trimmed.slice(0, atIndex);
  const domain = trimmed.slice(atIndex + 1);
  const dotIndex = domain.indexOf(".");
  if (dotIndex === -1) {
    return `${maskPart(local, visibleChars)}@${maskPart(domain, visibleChars)}`;
  }
  const domainName = domain.slice(0, dotIndex);
  const tlds = domain.slice(dotIndex + 1);
  return `${maskPart(local, visibleChars)}@${maskPart(domainName, visibleChars)}.${tlds}`;
}

/**
 * Preserves the original format (spaces, dashes).
 * Example: "+56 9 1234 5678" with visibleEnd=4 → "*******5678"
 */
export function maskPhone(
  phone: string,
  visibleEnd: number = DEFAULT_PHONE_VISIBLE_END,
): string {
  const raw = phone.trim();
  if (!raw) return "***";
  const digits = raw.replace(/\D/g, "");
  if (digits.length === 0) return raw;
  const visibleCount = Math.min(visibleEnd, digits.length);
  const maskedDigits =
    "*".repeat(digits.length - visibleCount) + digits.slice(-visibleCount);
  let i = 0;
  return raw.replace(/\d/g, () => maskedDigits[i++]);
}
